export default class PagedResultSet<T> {
    constructor() {
        this.items = new Array<T>();
    }

    public items: T[];
    public totalRecords: number;
    public pageNumber: number;
    public pageSize: number;

    // get itemCount() {
    //     return this.items ? this.items.length : 0;
    // }

    // public static from<T>(payload: any) {
    //     const resultSet = new PagedResultSet<T>();
    //     resultSet.items = payload.items;
    //     resultSet.totalRecords = payload.totalRecords;
    //     resultSet.pageNumber = payload.pageNumber;
    //     resultSet.pageSize = payload.pageSize;

    //     return resultSet;
    // }
}



// WEBPACK FOOTER //
// ./src/models/common/PagedResultSet.ts